module.exports = "<h1>Unauthorized access.</h1> <p class=lead> Please relogin as other user <a href=/login>here</a>. </p> ";


//////////////////
// WEBPACK FOOTER
// ./client/src/app/unauthorized.tpl.html
// module id = 316
// module chunks = 2